import { render } from "./FundAlert.vue?vue&type=template&id=1c4581ed&ts=true"
import script from "./FundAlert.vue?vue&type=script&lang=ts"
export * from "./FundAlert.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__